import styles from "./NavTopBarBodyStart.module.scss"
import { NavTopBarBodyStartProps } from "./NavTopBarBodyStart.types"

export default function NavTopBarBodyStart(props: NavTopBarBodyStartProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
